import { Star } from 'lucide-react';
import { vipBadge } from './vipBadge';

// Douyin-live-room style level badge: a metal-colored pill with a star (or the
// full 1–4 stars in `full` variant) followed by the level number. Sits before
// the username. `compact` (chat) shows a single star; `full` (profile/detail)
// shows the sub-rank stars.
export function VipLevelBadge({ level, variant = 'compact' }: { level: number; variant?: 'compact' | 'full' }) {
  const badge = vipBadge(level);
  const starCount = variant === 'full' ? badge.stars : 1;
  return (
    <span className={`vip-badge vip-badge-${badge.family}`} aria-label={`VIP ${badge.level}`}>
      {Array.from({ length: starCount }).map((_, index) => (
        <Star key={index} size={9} fill="currentColor" strokeWidth={0} aria-hidden="true" />
      ))}
      <b>{badge.level}</b>
    </span>
  );
}
